import React from 'react';
import {
  Menu,
  MenuTrigger,
  MenuPopover,
  MenuList,
  MenuItem,
} from '@fluentui/react-components';
import {
  Delete20Regular,
  Edit20Regular,
  MoreHorizontal20Regular,
} from '@fluentui/react-icons';
import { useTranslation } from 'react-i18next';

/**
 * Composant label pour le nœud Routing
 */
const RoutingNodeLabel = ({ routingKey, routing, handleEditNode, handleDeleteNode }) => {
  const { t } = useTranslation();
  const routingId = routingKey === '0' ? 'routing-0' : `routing-${routingKey}`;
  const displayName = routingKey === '0' ? 'Start' : (routing.displayName || routing.routingName || routingKey);
  const isDefaultRouting = routingKey === '0';
  const rawType = routing.type || 'queue';
  
  // Traduire le type de routing
  const getTranslatedType = (type) => {
    switch(type) {
      case 'check_variable': return t('checkVariable');
      case 'check_days': return t('checkDays');
      case 'regexp': return t('regexp');
      case 'time': return t('time');
      case 'prompt': return t('prompt');
      case 'ivr': return 'IVR';
      case 'queue': return t('queue');
      case 'disconnect': return t('disconnect');
      case 'transfer': return 'Transfer';
      default: return type;
    }
  };
  
  const routingType = getTranslatedType(rawType);

  return (
    <div className="node-routing">
      <Menu>
        <MenuTrigger disableButtonEnhancement>
          <button
            className="node-menu-btn"
            onClick={(e) => e.stopPropagation()}
            title="Options"
          >
            <MoreHorizontal20Regular />
          </button>
        </MenuTrigger>
        <MenuPopover>
          <MenuList>
            <MenuItem
              icon={<Edit20Regular />}
              onClick={(e) => {
                e.stopPropagation();
                handleEditNode(routingId);
              }}
            >
              Éditer
            </MenuItem>
            {!isDefaultRouting && (
              <MenuItem
                icon={<Delete20Regular />}
                onClick={(e) => {
                  e.stopPropagation();
                  handleDeleteNode(routingId);
                }}
              >
                Supprimer
              </MenuItem>
            )}
          </MenuList>
        </MenuPopover>
      </Menu>
      <div className="node-title">{displayName}</div>
      <div className="node-separator"></div>
      <div className="node-info">
        <div className="node-info-item">{routingType}</div>
      </div>
    </div>
  );
};

export default RoutingNodeLabel;
